import React from 'react';

import { Form, List } from 'antd';

import { Colors } from '@common/tokens';
import { SpearfishableWorkersByShiftGapQueryCgResponse } from '@common/graphql/schema';

export const RecipientsList = ({
  spearfishableWorkerData,
}: {
  spearfishableWorkerData:
    | SpearfishableWorkersByShiftGapQueryCgResponse
    | undefined;
}) => {
  return (
    <div className="wk-home-unit-recipients-list-container">
      <div className="wk-home-unit-recipients-header ant-list-item">Staff</div>
      <Form.Item className="always-show-scrollbar wk-home-unit-recipients-list-form-item">
        <List
          dataSource={spearfishableWorkerData?.spearfishableWorkersByShiftGap}
          renderItem={(item) => (
            <List.Item
              key={item?.worker?.id}
              className="wk-home-unit-recipients-list-item"
              style={{
                color: item?.spearfishable
                  ? Colors.midnightDarker
                  : Colors.midnightLighter,
              }}
            >
              <>{item?.worker?.worksUser?.name}</>
              <div className="wk-home-unit-recipients-list-spearfishing-detail">
                {item?.spearfishingDetail}
              </div>
            </List.Item>
          )}
        />
      </Form.Item>
      <style jsx>
        {`
          :global(.wk-home-unit-recipients-header) {
            position: sticky;
            top: 0;
            color: ${Colors.midnightRegular};
            border-radius: 8px 8px 0 0;
            background-color: ${Colors.steelLightest};
            padding: 8px 8px;
            border-bottom: 1px solid #f0f0f0;
            height: 40px;
          }

          :global(.wk-home-unit-recipients-list-container) {
            border: 1px solid ${Colors.steel};
            border-radius: 8px;
            margin-bottom: 24px;
          }

          :global(.wk-home-unit-recipients-list-form-item) {
            max-height: 20vh;
            flex-grow: 1;
            margin-bottom: 0;
            overflow-y: auto;
          }

          :global(.wk-home-unit-recipients-list-item) {
            margin-bottom: 0px;
            padding: 16px 4px 16px 8px;
            height: 20px;
          }

          :global(.wk-home-unit-recipients-list-spearfishing-detail) {
            margin-right: 4px;
            color: ${Colors.midnightLighter};
          }

          :global(.always-show-scrollbar::-webkit-scrollbar) {
            width: 12px;
          }

          :global(.always-show-scrollbar::-webkit-scrollbar-track) {
            background: #f1f1f1;
          }

          :global(.always-show-scrollbar::-webkit-scrollbar-thumb) {
            background-color: #888;
            border-radius: 10px;
            border: 3px solid #f1f1f1;
          }

          :global(.always-show-scrollbar::-webkit-scrollbar-thumb:hover) {
            background: #555;
          }
        `}
      </style>
    </div>
  );
};
